export default __webpack_public_path__ + "static/media/venues1.4ea0b416.jpg";